// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DocumentationWarningPopup-module__font-s-10___g9PPG {
  font-size: 10px !important;
}

.DocumentationWarningPopup-module__font-s-12___UOG6L {
  font-size: 12px !important;
}

.DocumentationWarningPopup-module__font-s-13___iZ_Zf {
  font-size: 13px !important;
}

.DocumentationWarningPopup-module__font-s-14___xLO7z {
  font-size: 14px !important;
}

.DocumentationWarningPopup-module__font-s-15___racYx {
  font-size: 15px !important;
}

.DocumentationWarningPopup-module__font-s-16___YgyGE {
  font-size: 16px !important;
}

.DocumentationWarningPopup-module__font-s-18___rNVRL {
  font-size: 18px !important;
}

.DocumentationWarningPopup-module__font-s-20___RfdOj {
  font-size: 20px !important;
}

.DocumentationWarningPopup-module__font-s-22___DRjKN {
  font-size: 22px !important;
}

.DocumentationWarningPopup-module__font-s-28___nS06y {
  font-size: 28px !important;
}

.DocumentationWarningPopup-module__font-w-400___A9Ydx {
  font-weight: 400 !important;
}

.DocumentationWarningPopup-module__font-w-500___qr6KY {
  font-weight: 500 !important;
}

.DocumentationWarningPopup-module__font-w-600___zy5hS {
  font-weight: 600 !important;
}

.DocumentationWarningPopup-module__font-w-700___Y68lp {
  font-weight: 700 !important;
}

.DocumentationWarningPopup-module__p-5___alRRy {
  padding: 5px !important;
}

.DocumentationWarningPopup-module__p-12___HIarW {
  padding: 12px !important;
}

.DocumentationWarningPopup-module__p-16___Qe4ig {
  padding: 16px !important;
}

.DocumentationWarningPopup-module__p-30___t3RRh {
  padding: 30px !important;
}

.DocumentationWarningPopup-module__p-b-0___fCY67 {
  padding-bottom: 0 !important;
}

.DocumentationWarningPopup-module__p-b-5___kmujg {
  padding-bottom: 5px !important;
}

.DocumentationWarningPopup-module__p-b-10___jJ_ma {
  padding-bottom: 10px !important;
}

.DocumentationWarningPopup-module__p-b-12___sEy0I {
  padding-bottom: 12px !important;
}

.DocumentationWarningPopup-module__p-b-16___HkM20 {
  padding-bottom: 16px !important;
}

.DocumentationWarningPopup-module__p-b-18___W2pRv {
  padding-bottom: 18px !important;
}

.DocumentationWarningPopup-module__p-b-20___NsmOB {
  padding-bottom: 20px !important;
}

.DocumentationWarningPopup-module__p-b-25___ywJxu {
  padding-bottom: 25px !important;
}

.DocumentationWarningPopup-module__p-b-30___Lh87k {
  padding-bottom: 30px !important;
}

.DocumentationWarningPopup-module__p-b-50___e26yz {
  padding-bottom: 50px !important;
}

.DocumentationWarningPopup-module__p-t-0___jrbjG {
  padding-top: 0 !important;
}

.DocumentationWarningPopup-module__p-t-12___MB8px {
  padding-top: 12px !important;
}

.DocumentationWarningPopup-module__p-t-16___rcxwL {
  padding-top: 16px !important;
}

.DocumentationWarningPopup-module__p-t-18___QeHMX {
  padding-top: 18px !important;
}

.DocumentationWarningPopup-module__p-t-20___laNLV {
  padding-top: 20px !important;
}

.DocumentationWarningPopup-module__p-t-30___vKeXA {
  padding-top: 30px !important;
}

.DocumentationWarningPopup-module__p-t-40___vffb0 {
  padding-top: 40px !important;
}

.DocumentationWarningPopup-module__p-t-50___Z3eAZ {
  padding-top: 50px !important;
}

.DocumentationWarningPopup-module__p-l-20___QhwGA {
  padding-left: 20px !important;
}

.DocumentationWarningPopup-module__p-l-30___MEOYH {
  padding-left: 30px !important;
}

.DocumentationWarningPopup-module__p-l-40___zAGoc {
  padding-left: 40px !important;
}

.DocumentationWarningPopup-module__p-r-16____sUgH {
  padding-right: 16px !important;
}

.DocumentationWarningPopup-module__p-r-20___NYysp {
  padding-right: 20px !important;
}

.DocumentationWarningPopup-module__p-r-30___N_zi8 {
  padding-right: 30px !important;
}

.DocumentationWarningPopup-module__p-r-50___Yccst {
  padding-right: 50px !important;
}

.DocumentationWarningPopup-module__p-r-60___Wykr4 {
  padding-right: 60px !important;
}

.DocumentationWarningPopup-module__m-b-1___Il8HP {
  margin-bottom: 1px !important;
}

.DocumentationWarningPopup-module__m-b-2___gy_LN {
  margin-bottom: 2px !important;
}

.DocumentationWarningPopup-module__m-b-6___xGDBk {
  margin-bottom: 6px !important;
}

.DocumentationWarningPopup-module__m-b-8___vPnjO {
  margin-bottom: 8px !important;
}

.DocumentationWarningPopup-module__m-b-10___t_D2i {
  margin-bottom: 10px !important;
}

.DocumentationWarningPopup-module__m-b-14___JCIji {
  margin-bottom: 14px !important;
}

.DocumentationWarningPopup-module__m-b-16___LC42i {
  margin-bottom: 16px !important;
}

.DocumentationWarningPopup-module__m-b-20___snfmY {
  margin-bottom: 20px !important;
}

.DocumentationWarningPopup-module__m-b-22___LXzWP {
  margin-bottom: 22px !important;
}

.DocumentationWarningPopup-module__m-b-24___AAgL_ {
  margin-bottom: 24px !important;
}

.DocumentationWarningPopup-module__m-b-30___cevdQ {
  margin-bottom: 30px !important;
}

.DocumentationWarningPopup-module__m-b-32___zVGoh {
  margin-bottom: 32px !important;
}

.DocumentationWarningPopup-module__m-b-40___j6aSx {
  margin-bottom: 40px !important;
}

.DocumentationWarningPopup-module__m-t-2___pNAHF {
  margin-top: 2px !important;
}

.DocumentationWarningPopup-module__m-t-3___dzfy2 {
  margin-top: 3px !important;
}

.DocumentationWarningPopup-module__m-t-4___lkc8S {
  margin-top: 4px !important;
}

.DocumentationWarningPopup-module__m-t-5___Sxzj_ {
  margin-top: 5px !important;
}

.DocumentationWarningPopup-module__m-t-8___QlKeC {
  margin-top: 8px !important;
}

.DocumentationWarningPopup-module__m-t-10___Akgfs {
  margin-top: 10px !important;
}

.DocumentationWarningPopup-module__m-t-15___eDoyN {
  margin-top: 15px !important;
}

.DocumentationWarningPopup-module__m-t-16___f8LMc {
  margin-top: 16px !important;
}

.DocumentationWarningPopup-module__m-t-20___nPtGs {
  margin-top: 20px !important;
}

.DocumentationWarningPopup-module__m-t-22___eTKda {
  margin-top: 22px !important;
}

.DocumentationWarningPopup-module__m-t-30___BwN00 {
  margin-top: 30px !important;
}

.DocumentationWarningPopup-module__m-t-32___hE918 {
  margin-top: 32px !important;
}

.DocumentationWarningPopup-module__m-l-auto___rr5ih {
  margin-left: auto !important;
}

.DocumentationWarningPopup-module__m-l-4___OXEZo {
  margin-left: 4px !important;
}

.DocumentationWarningPopup-module__m-l-5___oBuzf {
  margin-left: 5px !important;
}

.DocumentationWarningPopup-module__m-l-6___wHfD5 {
  margin-left: 6px !important;
}

.DocumentationWarningPopup-module__m-l-8___Nrm_N {
  margin-left: 8px !important;
}

.DocumentationWarningPopup-module__m-l-10___FU7Ca {
  margin-left: 10px !important;
}

.DocumentationWarningPopup-module__m-l-16___oz29x {
  margin-left: 16px !important;
}

.DocumentationWarningPopup-module__m-l-20___pdE7c {
  margin-left: 20px !important;
}

.DocumentationWarningPopup-module__m-l-24___oCAIx {
  margin-left: 24px !important;
}

.DocumentationWarningPopup-module__m-l-30___oCiYN {
  margin-left: 30px !important;
}

.DocumentationWarningPopup-module__m-l-35____aTIY {
  margin-left: 35px !important;
}

.DocumentationWarningPopup-module__m-l-40___O7vPt {
  margin-left: 40px !important;
}

.DocumentationWarningPopup-module__m-r-8___dpDk3 {
  margin-right: 8px !important;
}

.DocumentationWarningPopup-module__m-r-10___v8Cgu {
  margin-right: 10px !important;
}

.DocumentationWarningPopup-module__m-r-16___DZByi {
  margin-right: 16px !important;
}

.DocumentationWarningPopup-module__m-r-20___o9eIe {
  margin-right: 20px !important;
}

.DocumentationWarningPopup-module__m-r-24___ZOBH9 {
  margin-right: 24px !important;
}

.DocumentationWarningPopup-module__m-r-30___A7lmp {
  margin-right: 30px !important;
}

.DocumentationWarningPopup-module__m-r-40___p0IGu {
  margin-right: 40px !important;
}

.DocumentationWarningPopup-module__border-r-3___NIpE8 {
  border-radius: 3px !important;
}

.DocumentationWarningPopup-module__border-r-4___IpXEo {
  border-radius: 4px !important;
}

.DocumentationWarningPopup-module__border-r-6___b7yBV {
  border-radius: 6px !important;
}

.DocumentationWarningPopup-module__border-r-10___vku8Y {
  border-radius: 10px !important;
}

.DocumentationWarningPopup-module__border-r-12___FYn68 {
  border-radius: 12px !important;
}

.DocumentationWarningPopup-module__border-r-16___yOMFa {
  border-radius: 16px !important;
}

.DocumentationWarningPopup-module__border-r-50___jxEJj {
  border-radius: 50% !important;
}

.DocumentationWarningPopup-module__primary-border___bPXo6 {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.DocumentationWarningPopup-module__primary-border-b___eMvH4 {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.DocumentationWarningPopup-module__primary-border-t___J0zPQ {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.DocumentationWarningPopup-module__primary-border-l___bx_fF {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.DocumentationWarningPopup-module__primary-border-r___llNTm {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.DocumentationWarningPopup-module__secondary-border___mzSk7 {
  border: 1px solid #637768;
}

.DocumentationWarningPopup-module__secondary-border-b___nqiW6 {
  border-bottom: 1px solid #637768;
}

.DocumentationWarningPopup-module__secondary-border-t___axwIP {
  border-top: 1px solid #637768;
}

.DocumentationWarningPopup-module__secondary-border-l____kjGH {
  border-left: 1px solid #637768;
}

.DocumentationWarningPopup-module__secondary-border-r___kRrI5 {
  border-right: 1px solid #637768;
}

.DocumentationWarningPopup-module__gap-0___hBGnQ {
  gap: 0 !important;
}

.DocumentationWarningPopup-module__gap-2___bPWcd {
  gap: 2px !important;
}

.DocumentationWarningPopup-module__gap-4___S4KHs {
  gap: 4px !important;
}

.DocumentationWarningPopup-module__gap-5___l0vNB {
  gap: 5px !important;
}

.DocumentationWarningPopup-module__gap-6___OaZ_J {
  gap: 6px !important;
}

.DocumentationWarningPopup-module__gap-8___PJ3xw {
  gap: 8px !important;
}

.DocumentationWarningPopup-module__gap-10___xCidR {
  gap: 10px !important;
}

.DocumentationWarningPopup-module__gap-12___zsj7Y {
  gap: 12px !important;
}

.DocumentationWarningPopup-module__gap-14___fb0aZ {
  gap: 14px !important;
}

.DocumentationWarningPopup-module__gap-16___ldN7S {
  gap: 16px !important;
}

.DocumentationWarningPopup-module__gap-18___gKf9s {
  gap: 18px !important;
}

.DocumentationWarningPopup-module__gap-20___R4FLs {
  gap: 20px !important;
}

.DocumentationWarningPopup-module__gap-24___eiilY {
  gap: 24px !important;
}

.DocumentationWarningPopup-module__gap-26___comlY {
  gap: 26px !important;
}

.DocumentationWarningPopup-module__gap-30___XLLca {
  gap: 30px !important;
}

.DocumentationWarningPopup-module__gap-32___t4Zvv {
  gap: 32px !important;
}

.DocumentationWarningPopup-module__gap-40___CHJtE {
  gap: 40px !important;
}

.DocumentationWarningPopup-module__gap-50___H8XE6 {
  gap: 50px !important;
}

.DocumentationWarningPopup-module__flex-1___M3wyz {
  flex: 1;
}

.DocumentationWarningPopup-module__flex-none___HJk_h {
  flex: none !important;
}

.DocumentationWarningPopup-module__flex-column___pclpr {
  display: flex;
  flex-direction: column !important;
}

.DocumentationWarningPopup-module__flex-row___EvXWT {
  display: flex;
  flex-direction: row !important;
}

.DocumentationWarningPopup-module__vertically-centered___JbFJj {
  display: flex;
  align-items: center !important;
}

.DocumentationWarningPopup-module__horizontally-centered___AJs6G {
  display: flex;
  justify-content: center !important;
}

.DocumentationWarningPopup-module__horizontally-end___wsBE3 {
  display: flex;
  justify-content: end !important;
}

.DocumentationWarningPopup-module__vertically-start___x9o7p {
  display: flex;
  align-items: start !important;
}

.DocumentationWarningPopup-module__space-between___EGtCI {
  display: flex;
  justify-content: space-between !important;
}

.DocumentationWarningPopup-module__flex-wrap___YxFcn {
  flex-wrap: wrap !important;
}

.DocumentationWarningPopup-module__height-100___KPGaG {
  height: 100%;
}

.DocumentationWarningPopup-module__width-50___YqRhJ {
  width: 50% !important;
}

.DocumentationWarningPopup-module__width-100___v775H {
  width: 100%;
}

.DocumentationWarningPopup-module__cursor-pointer___v8MFU {
  cursor: pointer;
}

.DocumentationWarningPopup-module__cursor-not-allowed___w3oHR {
  cursor: not-allowed !important;
}

.DocumentationWarningPopup-module__absolute-centered___rTcJb {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.DocumentationWarningPopup-module__absolute___Ojjpw {
  position: absolute;
}

.DocumentationWarningPopup-module__relative___LNOuM {
  position: relative;
}

.DocumentationWarningPopup-module__fixed___RtKYK {
  position: fixed;
}

.DocumentationWarningPopup-module__visible___hNayv {
  opacity: 1;
}

.DocumentationWarningPopup-module__invisible___NWW34 {
  opacity: 0;
}

.DocumentationWarningPopup-module__col-90___G0hyx {
  width: 90% !important;
}

.DocumentationWarningPopup-module__col-auto___pBYoa {
  width: auto !important;
}

.DocumentationWarningPopup-module__medical-tabs___PrH1A {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.DocumentationWarningPopup-module__medical-table-new___vMfPq {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.DocumentationWarningPopup-module__medical-table-new___vMfPq:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.DocumentationWarningPopup-module__medical-table-new___vMfPq::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.DocumentationWarningPopup-module__medical-table-new___vMfPq::-webkit-scrollbar-track {
  display: none;
}
.DocumentationWarningPopup-module__medical-table-new___vMfPq.DocumentationWarningPopup-module__no-pagination___fIuid {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.DocumentationWarningPopup-module__medical-table-new___vMfPq.DocumentationWarningPopup-module__no-pagination___fIuid:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.DocumentationWarningPopup-module__medical-table-new___vMfPq.DocumentationWarningPopup-module__no-pagination___fIuid::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.DocumentationWarningPopup-module__medical-table-new___vMfPq.DocumentationWarningPopup-module__no-pagination___fIuid::-webkit-scrollbar-track {
  display: none;
}

.DocumentationWarningPopup-module__medical-table-empty___k3ohn {
  padding: 14px 40px !important;
}

.DocumentationWarningPopup-module__icon-btn___OvJdZ {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.DocumentationWarningPopup-module__search-icon___H9EmC {
  width: 24px;
  height: 24px;
  align-self: center;
}

.DocumentationWarningPopup-module__disable-select___JsjZq {
  user-select: none;
}

.DocumentationWarningPopup-module__break-word___AGmEm {
  word-break: break-word;
}

.DocumentationWarningPopup-module__popup-clear-btn___ISwgk {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.DocumentationWarningPopup-module__scroll-m-b-20___vj9jL {
  scroll-margin-bottom: 20px;
}

.DocumentationWarningPopup-module__text___fBgeY, .DocumentationWarningPopup-module__wrapper___Uspg0 .DocumentationWarningPopup-module__subtitle___WhWaC, .DocumentationWarningPopup-module__wrapper___Uspg0 .DocumentationWarningPopup-module__titleContainer___KsKRN .DocumentationWarningPopup-module__title___UD4YA {
  font-family: var(--font-family);
  font-weight: 500;
  font-size: 1rem;
  color: black;
}

.DocumentationWarningPopup-module__wrapper___Uspg0 {
  height: 480px;
  padding: 40px 50px 30px 50px;
}
.DocumentationWarningPopup-module__wrapper___Uspg0 .DocumentationWarningPopup-module__titleContainer___KsKRN {
  display: flex;
}
.DocumentationWarningPopup-module__wrapper___Uspg0 .DocumentationWarningPopup-module__titleContainer___KsKRN .DocumentationWarningPopup-module__title___UD4YA {
  flex: 1;
}
.DocumentationWarningPopup-module__wrapper___Uspg0 .DocumentationWarningPopup-module__subtitle___WhWaC {
  margin-right: 20px;
}
.DocumentationWarningPopup-module__wrapper___Uspg0 .DocumentationWarningPopup-module__drafts___mlQWI {
  margin: 2em 0;
  overflow-y: auto;
  flex: 1;
}
.DocumentationWarningPopup-module__wrapper___Uspg0 .DocumentationWarningPopup-module__buttons___ZkJ6A {
  display: flex;
  flex-direction: row;
  justify-content: end;
  padding: 19px 30px;
  gap: 16px;
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}
.DocumentationWarningPopup-module__wrapper___Uspg0 .DocumentationWarningPopup-module__buttons___ZkJ6A .DocumentationWarningPopup-module__button___q2o1u {
  display: flex;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/popups/DocumentationWarningPopup/DocumentationWarningPopup.module.scss","webpack://./../common/src/styles/global/_mixins.scss","webpack://./../common/src/styles/global/_fonts.scss","webpack://./../common/src/styles/global/_weights.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EEwBE,+BApBO;EAqBP,gBCxBO;EDyBP,eAAA;EFxBA,YAAA;AAgqBF;;AA7pBA;EACE,aAAA;EACA,4BAAA;AAgqBF;AA9pBE;EACE,aAAA;AAgqBJ;AA9pBI;EAEE,OAAA;AA+pBN;AA3pBE;EAEE,kBAAA;AA4pBJ;AAzpBE;EACE,aAAA;EACA,gBAAA;EACA,OAAA;AA2pBJ;AAxpBE;EACE,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,SAAA;EACA,2CAAA;AA0pBJ;AAxpBI;EACE,aAAA;AA0pBN","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.text {\n  @include get-font($roboto, $medium, medium);\n  color: get-color(black);\n}\n\n.wrapper {\n  height: 480px;\n  padding: 40px 50px 30px 50px;\n\n  .titleContainer {\n    display: flex;\n\n    .title {\n      @extend .text;\n      flex: 1;\n    }\n  }\n\n  .subtitle {\n    @extend .text;\n    margin-right: 20px;\n  }\n\n  .drafts {\n    margin: 2em 0;\n    overflow-y: auto;\n    flex: 1;\n  }\n\n  .buttons {\n    display: flex;\n    flex-direction: row;\n    justify-content: end;\n    padding: 19px 30px;\n    gap: 16px;\n    border-top: 1px solid rgba(91, 91, 91, 0.2);\n\n    .button {\n      display: flex;\n    }\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n","@use 'sass:map';\n@use 'sass:meta';\n@use 'sizes';\n\n// font families\n// TODO: rename this variable\n$roboto: var(--font-family);\n\n// functions\n@function get-font-size($font-size: null) {\n  // check font size exists\n  @if (map.has-key(sizes.$font-sizes, $font-size)) {\n    $value: map.get(sizes.$font-sizes, $font-size);\n    @if meta.type-of($value) == number {\n      // return font size\n      @return $value;\n    }\n\n    @return null;\n  }\n\n  @return null;\n}\n\n// mixins\n@mixin get-font($font-family: $roboto, $font-weight: 400, $font-size: null) {\n  font-family: $font-family;\n  font-weight: $font-weight;\n  font-size: get-font-size($font-size);\n}\n","$extra-light: 200;\n$light: 300;\n$regular: 400;\n$medium: 500;\n$semi-bold: 600;\n$bold: 700;\n$heavy: 900;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `DocumentationWarningPopup-module__font-s-10___g9PPG`,
	"fontS12": `DocumentationWarningPopup-module__font-s-12___UOG6L`,
	"fontS13": `DocumentationWarningPopup-module__font-s-13___iZ_Zf`,
	"fontS14": `DocumentationWarningPopup-module__font-s-14___xLO7z`,
	"fontS15": `DocumentationWarningPopup-module__font-s-15___racYx`,
	"fontS16": `DocumentationWarningPopup-module__font-s-16___YgyGE`,
	"fontS18": `DocumentationWarningPopup-module__font-s-18___rNVRL`,
	"fontS20": `DocumentationWarningPopup-module__font-s-20___RfdOj`,
	"fontS22": `DocumentationWarningPopup-module__font-s-22___DRjKN`,
	"fontS28": `DocumentationWarningPopup-module__font-s-28___nS06y`,
	"fontW400": `DocumentationWarningPopup-module__font-w-400___A9Ydx`,
	"fontW500": `DocumentationWarningPopup-module__font-w-500___qr6KY`,
	"fontW600": `DocumentationWarningPopup-module__font-w-600___zy5hS`,
	"fontW700": `DocumentationWarningPopup-module__font-w-700___Y68lp`,
	"p5": `DocumentationWarningPopup-module__p-5___alRRy`,
	"p12": `DocumentationWarningPopup-module__p-12___HIarW`,
	"p16": `DocumentationWarningPopup-module__p-16___Qe4ig`,
	"p30": `DocumentationWarningPopup-module__p-30___t3RRh`,
	"pB0": `DocumentationWarningPopup-module__p-b-0___fCY67`,
	"pB5": `DocumentationWarningPopup-module__p-b-5___kmujg`,
	"pB10": `DocumentationWarningPopup-module__p-b-10___jJ_ma`,
	"pB12": `DocumentationWarningPopup-module__p-b-12___sEy0I`,
	"pB16": `DocumentationWarningPopup-module__p-b-16___HkM20`,
	"pB18": `DocumentationWarningPopup-module__p-b-18___W2pRv`,
	"pB20": `DocumentationWarningPopup-module__p-b-20___NsmOB`,
	"pB25": `DocumentationWarningPopup-module__p-b-25___ywJxu`,
	"pB30": `DocumentationWarningPopup-module__p-b-30___Lh87k`,
	"pB50": `DocumentationWarningPopup-module__p-b-50___e26yz`,
	"pT0": `DocumentationWarningPopup-module__p-t-0___jrbjG`,
	"pT12": `DocumentationWarningPopup-module__p-t-12___MB8px`,
	"pT16": `DocumentationWarningPopup-module__p-t-16___rcxwL`,
	"pT18": `DocumentationWarningPopup-module__p-t-18___QeHMX`,
	"pT20": `DocumentationWarningPopup-module__p-t-20___laNLV`,
	"pT30": `DocumentationWarningPopup-module__p-t-30___vKeXA`,
	"pT40": `DocumentationWarningPopup-module__p-t-40___vffb0`,
	"pT50": `DocumentationWarningPopup-module__p-t-50___Z3eAZ`,
	"pL20": `DocumentationWarningPopup-module__p-l-20___QhwGA`,
	"pL30": `DocumentationWarningPopup-module__p-l-30___MEOYH`,
	"pL40": `DocumentationWarningPopup-module__p-l-40___zAGoc`,
	"pR16": `DocumentationWarningPopup-module__p-r-16____sUgH`,
	"pR20": `DocumentationWarningPopup-module__p-r-20___NYysp`,
	"pR30": `DocumentationWarningPopup-module__p-r-30___N_zi8`,
	"pR50": `DocumentationWarningPopup-module__p-r-50___Yccst`,
	"pR60": `DocumentationWarningPopup-module__p-r-60___Wykr4`,
	"mB1": `DocumentationWarningPopup-module__m-b-1___Il8HP`,
	"mB2": `DocumentationWarningPopup-module__m-b-2___gy_LN`,
	"mB6": `DocumentationWarningPopup-module__m-b-6___xGDBk`,
	"mB8": `DocumentationWarningPopup-module__m-b-8___vPnjO`,
	"mB10": `DocumentationWarningPopup-module__m-b-10___t_D2i`,
	"mB14": `DocumentationWarningPopup-module__m-b-14___JCIji`,
	"mB16": `DocumentationWarningPopup-module__m-b-16___LC42i`,
	"mB20": `DocumentationWarningPopup-module__m-b-20___snfmY`,
	"mB22": `DocumentationWarningPopup-module__m-b-22___LXzWP`,
	"mB24": `DocumentationWarningPopup-module__m-b-24___AAgL_`,
	"mB30": `DocumentationWarningPopup-module__m-b-30___cevdQ`,
	"mB32": `DocumentationWarningPopup-module__m-b-32___zVGoh`,
	"mB40": `DocumentationWarningPopup-module__m-b-40___j6aSx`,
	"mT2": `DocumentationWarningPopup-module__m-t-2___pNAHF`,
	"mT3": `DocumentationWarningPopup-module__m-t-3___dzfy2`,
	"mT4": `DocumentationWarningPopup-module__m-t-4___lkc8S`,
	"mT5": `DocumentationWarningPopup-module__m-t-5___Sxzj_`,
	"mT8": `DocumentationWarningPopup-module__m-t-8___QlKeC`,
	"mT10": `DocumentationWarningPopup-module__m-t-10___Akgfs`,
	"mT15": `DocumentationWarningPopup-module__m-t-15___eDoyN`,
	"mT16": `DocumentationWarningPopup-module__m-t-16___f8LMc`,
	"mT20": `DocumentationWarningPopup-module__m-t-20___nPtGs`,
	"mT22": `DocumentationWarningPopup-module__m-t-22___eTKda`,
	"mT30": `DocumentationWarningPopup-module__m-t-30___BwN00`,
	"mT32": `DocumentationWarningPopup-module__m-t-32___hE918`,
	"mLAuto": `DocumentationWarningPopup-module__m-l-auto___rr5ih`,
	"mL4": `DocumentationWarningPopup-module__m-l-4___OXEZo`,
	"mL5": `DocumentationWarningPopup-module__m-l-5___oBuzf`,
	"mL6": `DocumentationWarningPopup-module__m-l-6___wHfD5`,
	"mL8": `DocumentationWarningPopup-module__m-l-8___Nrm_N`,
	"mL10": `DocumentationWarningPopup-module__m-l-10___FU7Ca`,
	"mL16": `DocumentationWarningPopup-module__m-l-16___oz29x`,
	"mL20": `DocumentationWarningPopup-module__m-l-20___pdE7c`,
	"mL24": `DocumentationWarningPopup-module__m-l-24___oCAIx`,
	"mL30": `DocumentationWarningPopup-module__m-l-30___oCiYN`,
	"mL35": `DocumentationWarningPopup-module__m-l-35____aTIY`,
	"mL40": `DocumentationWarningPopup-module__m-l-40___O7vPt`,
	"mR8": `DocumentationWarningPopup-module__m-r-8___dpDk3`,
	"mR10": `DocumentationWarningPopup-module__m-r-10___v8Cgu`,
	"mR16": `DocumentationWarningPopup-module__m-r-16___DZByi`,
	"mR20": `DocumentationWarningPopup-module__m-r-20___o9eIe`,
	"mR24": `DocumentationWarningPopup-module__m-r-24___ZOBH9`,
	"mR30": `DocumentationWarningPopup-module__m-r-30___A7lmp`,
	"mR40": `DocumentationWarningPopup-module__m-r-40___p0IGu`,
	"borderR3": `DocumentationWarningPopup-module__border-r-3___NIpE8`,
	"borderR4": `DocumentationWarningPopup-module__border-r-4___IpXEo`,
	"borderR6": `DocumentationWarningPopup-module__border-r-6___b7yBV`,
	"borderR10": `DocumentationWarningPopup-module__border-r-10___vku8Y`,
	"borderR12": `DocumentationWarningPopup-module__border-r-12___FYn68`,
	"borderR16": `DocumentationWarningPopup-module__border-r-16___yOMFa`,
	"borderR50": `DocumentationWarningPopup-module__border-r-50___jxEJj`,
	"primaryBorder": `DocumentationWarningPopup-module__primary-border___bPXo6`,
	"primaryBorderB": `DocumentationWarningPopup-module__primary-border-b___eMvH4`,
	"primaryBorderT": `DocumentationWarningPopup-module__primary-border-t___J0zPQ`,
	"primaryBorderL": `DocumentationWarningPopup-module__primary-border-l___bx_fF`,
	"primaryBorderR": `DocumentationWarningPopup-module__primary-border-r___llNTm`,
	"secondaryBorder": `DocumentationWarningPopup-module__secondary-border___mzSk7`,
	"secondaryBorderB": `DocumentationWarningPopup-module__secondary-border-b___nqiW6`,
	"secondaryBorderT": `DocumentationWarningPopup-module__secondary-border-t___axwIP`,
	"secondaryBorderL": `DocumentationWarningPopup-module__secondary-border-l____kjGH`,
	"secondaryBorderR": `DocumentationWarningPopup-module__secondary-border-r___kRrI5`,
	"gap0": `DocumentationWarningPopup-module__gap-0___hBGnQ`,
	"gap2": `DocumentationWarningPopup-module__gap-2___bPWcd`,
	"gap4": `DocumentationWarningPopup-module__gap-4___S4KHs`,
	"gap5": `DocumentationWarningPopup-module__gap-5___l0vNB`,
	"gap6": `DocumentationWarningPopup-module__gap-6___OaZ_J`,
	"gap8": `DocumentationWarningPopup-module__gap-8___PJ3xw`,
	"gap10": `DocumentationWarningPopup-module__gap-10___xCidR`,
	"gap12": `DocumentationWarningPopup-module__gap-12___zsj7Y`,
	"gap14": `DocumentationWarningPopup-module__gap-14___fb0aZ`,
	"gap16": `DocumentationWarningPopup-module__gap-16___ldN7S`,
	"gap18": `DocumentationWarningPopup-module__gap-18___gKf9s`,
	"gap20": `DocumentationWarningPopup-module__gap-20___R4FLs`,
	"gap24": `DocumentationWarningPopup-module__gap-24___eiilY`,
	"gap26": `DocumentationWarningPopup-module__gap-26___comlY`,
	"gap30": `DocumentationWarningPopup-module__gap-30___XLLca`,
	"gap32": `DocumentationWarningPopup-module__gap-32___t4Zvv`,
	"gap40": `DocumentationWarningPopup-module__gap-40___CHJtE`,
	"gap50": `DocumentationWarningPopup-module__gap-50___H8XE6`,
	"flex1": `DocumentationWarningPopup-module__flex-1___M3wyz`,
	"flexNone": `DocumentationWarningPopup-module__flex-none___HJk_h`,
	"flexColumn": `DocumentationWarningPopup-module__flex-column___pclpr`,
	"flexRow": `DocumentationWarningPopup-module__flex-row___EvXWT`,
	"verticallyCentered": `DocumentationWarningPopup-module__vertically-centered___JbFJj`,
	"horizontallyCentered": `DocumentationWarningPopup-module__horizontally-centered___AJs6G`,
	"horizontallyEnd": `DocumentationWarningPopup-module__horizontally-end___wsBE3`,
	"verticallyStart": `DocumentationWarningPopup-module__vertically-start___x9o7p`,
	"spaceBetween": `DocumentationWarningPopup-module__space-between___EGtCI`,
	"flexWrap": `DocumentationWarningPopup-module__flex-wrap___YxFcn`,
	"height100": `DocumentationWarningPopup-module__height-100___KPGaG`,
	"width50": `DocumentationWarningPopup-module__width-50___YqRhJ`,
	"width100": `DocumentationWarningPopup-module__width-100___v775H`,
	"cursorPointer": `DocumentationWarningPopup-module__cursor-pointer___v8MFU`,
	"cursorNotAllowed": `DocumentationWarningPopup-module__cursor-not-allowed___w3oHR`,
	"absoluteCentered": `DocumentationWarningPopup-module__absolute-centered___rTcJb`,
	"absolute": `DocumentationWarningPopup-module__absolute___Ojjpw`,
	"relative": `DocumentationWarningPopup-module__relative___LNOuM`,
	"fixed": `DocumentationWarningPopup-module__fixed___RtKYK`,
	"visible": `DocumentationWarningPopup-module__visible___hNayv`,
	"invisible": `DocumentationWarningPopup-module__invisible___NWW34`,
	"col90": `DocumentationWarningPopup-module__col-90___G0hyx`,
	"colAuto": `DocumentationWarningPopup-module__col-auto___pBYoa`,
	"medicalTabs": `DocumentationWarningPopup-module__medical-tabs___PrH1A`,
	"medicalTableNew": `DocumentationWarningPopup-module__medical-table-new___vMfPq`,
	"noPagination": `DocumentationWarningPopup-module__no-pagination___fIuid`,
	"medicalTableEmpty": `DocumentationWarningPopup-module__medical-table-empty___k3ohn`,
	"iconBtn": `DocumentationWarningPopup-module__icon-btn___OvJdZ`,
	"searchIcon": `DocumentationWarningPopup-module__search-icon___H9EmC`,
	"disableSelect": `DocumentationWarningPopup-module__disable-select___JsjZq`,
	"breakWord": `DocumentationWarningPopup-module__break-word___AGmEm`,
	"popupClearBtn": `DocumentationWarningPopup-module__popup-clear-btn___ISwgk`,
	"scrollMB20": `DocumentationWarningPopup-module__scroll-m-b-20___vj9jL`,
	"text": `DocumentationWarningPopup-module__text___fBgeY`,
	"wrapper": `DocumentationWarningPopup-module__wrapper___Uspg0`,
	"subtitle": `DocumentationWarningPopup-module__subtitle___WhWaC`,
	"titleContainer": `DocumentationWarningPopup-module__titleContainer___KsKRN`,
	"title": `DocumentationWarningPopup-module__title___UD4YA`,
	"drafts": `DocumentationWarningPopup-module__drafts___mlQWI`,
	"buttons": `DocumentationWarningPopup-module__buttons___ZkJ6A`,
	"button": `DocumentationWarningPopup-module__button___q2o1u`
};
module.exports = ___CSS_LOADER_EXPORT___;
